/* =========================================================================
   OhMy! PDP-Galerie mobil — Vorschaubilder wie bloomnu.com (v13, 23.09.2026).
   Großes Bild = die vorhandene Wisch-Reihe (.bloom-gallery__track, ein Bild pro
   Breite). Darunter .bloom-gallery__thumbs: Tipp auf ein Vorschaubild springt
   zum Bild, Wischen am großen Bild markiert das passende Vorschaubild und holt
   es in Sicht. Pfeile an den Enden der Reihe erscheinen nur, wenn es dort
   weitergeht.
   ========================================================================= */
(function () {
  'use strict';

  var smooth = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  function init(mobile) {
    if (mobile.dataset.ohmyThumbsReady) return;
    var track = mobile.querySelector('.bloom-gallery__track');
    var wrap = mobile.querySelector('[data-ohmy-thumbs-wrap]');
    if (!track || !wrap) return;
    mobile.dataset.ohmyThumbsReady = '1';

    var strip = wrap.querySelector('[data-ohmy-thumbs]');
    var prev = wrap.querySelector('[data-ohmy-thumbs-prev]');
    var next = wrap.querySelector('[data-ohmy-thumbs-next]');
    var cells = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(strip.children);
    var total = thumbs.length;
    var current = -1;

    function goTo(i) {
      var cell = cells[i];
      if (cell) track.scrollTo({ left: cell.offsetLeft - track.offsetLeft, behavior: smooth });
    }

    function revealThumb(t) {
      var left = t.offsetLeft - strip.offsetLeft;
      var right = left + t.offsetWidth;
      if (left < strip.scrollLeft + 8) {
        strip.scrollTo({ left: Math.max(0, left - 40), behavior: smooth });
      } else if (right > strip.scrollLeft + strip.clientWidth - 8) {
        strip.scrollTo({ left: right - strip.clientWidth + 40, behavior: smooth });
      }
    }

    function setActive(i) {
      if (i === current) return;
      current = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
      if (thumbs[i]) revealThumb(thumbs[i]);
    }

    function arrows() {
      var max = strip.scrollWidth - strip.clientWidth - 2;
      prev.dataset.off = String(strip.scrollLeft <= 2);
      next.dataset.off = String(strip.scrollLeft >= max);
    }

    thumbs.forEach(function (t, i) {
      t.setAttribute('role', 'button');
      t.setAttribute('tabindex', '0');
      t.setAttribute('aria-label', 'Bild ' + (i + 1) + ' von ' + total + ' zeigen');
      t.addEventListener('click', function () { setActive(i); goTo(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActive(i); goTo(i); }
      });
    });

    prev.addEventListener('click', function () { strip.scrollBy({ left: -strip.clientWidth * 0.8, behavior: smooth }); });
    next.addEventListener('click', function () { strip.scrollBy({ left: strip.clientWidth * 0.8, behavior: smooth }); });

    var raf1, raf2;
    track.addEventListener('scroll', function () {
      if (raf1) return;
      raf1 = requestAnimationFrame(function () {
        raf1 = 0;
        var w = cells[1] ? cells[1].offsetLeft - cells[0].offsetLeft : track.clientWidth;
        setActive(Math.min(total - 1, Math.max(0, Math.round(track.scrollLeft / Math.max(1, w)))));
      });
    }, { passive: true });
    strip.addEventListener('scroll', function () {
      if (!raf2) raf2 = requestAnimationFrame(function () { raf2 = 0; arrows(); });
    }, { passive: true });
    window.addEventListener('resize', arrows);

    setActive(0);
    arrows();
  }

  function boot() {
    document.querySelectorAll('.bloom-gallery__mobile').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* =========================================================================
   Sortenwechsel → Bild der Sorte (v15, 24.09.2026, Pierre: „wenn man die
   Sorte auswählt, soll das entsprechende Produktbild direkt aufpoppen“).
   Die Buybox meldet jede Auswahl als Event „bloom:variant“ (detail.variant mit
   .media = Medien-ID des Variantenbilds). Galeriezellen tragen data-media-id.
   Desktop: das große erste Mosaikbild blendet auf das Bild der Sorte über.
   Mobil: das große Bild wischt zur Zelle der Sorte (Vorschaubilder folgen).
   Reagiert nur auf einen echten Variantenwechsel — nicht beim Laden und nicht
   beim Wechsel der Vorratsmenge; mit ?variant= in der URL gleich beim Laden.
   ========================================================================= */
(function () {
  'use strict';

  var smooth = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  function swapHero(targetImg, animate) {
    var hero = document.querySelector('.bloom-gallery__grid .bloom-gallery__cell:first-child img');
    if (!hero || !targetImg || hero === targetImg) return;
    if (hero.getAttribute('src') === targetImg.getAttribute('src')) return;
    var apply = function () {
      hero.setAttribute('src', targetImg.getAttribute('src'));
      var srcset = targetImg.getAttribute('srcset');
      if (srcset) hero.setAttribute('srcset', srcset); else hero.removeAttribute('srcset');
      hero.setAttribute('alt', targetImg.getAttribute('alt') || '');
      hero.loading = 'eager';
      var show = function () { hero.style.opacity = '1'; };
      if (hero.complete) requestAnimationFrame(show); else hero.addEventListener('load', show, { once: true });
      setTimeout(show, 600);
    };
    if (!animate || smooth === 'auto') { apply(); return; }
    hero.style.transition = 'opacity .18s ease';
    hero.style.opacity = '0';
    setTimeout(apply, 180);
  }

  function scrollMobile(mediaId, animate) {
    var track = document.querySelector('.bloom-gallery__mobile .bloom-gallery__track');
    if (!track) return;
    var cell = track.querySelector('[data-media-id="' + mediaId + '"]');
    if (cell) track.scrollTo({ left: cell.offsetLeft - track.offsetLeft, behavior: animate ? smooth : 'auto' });
  }

  function showVariantImage(mediaId, animate) {
    if (!mediaId) return;
    var gridCell = document.querySelector('.bloom-gallery__grid [data-media-id="' + mediaId + '"]');
    if (gridCell) swapHero(gridCell.querySelector('img'), animate);
    scrollMobile(mediaId, animate);
  }

  function boot() {
    var idInput = document.querySelector('bloom-buybox [name="id"]');
    if (!idInput) return;
    var current = String(idInput.value);

    document.addEventListener('bloom:variant', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v || String(v.id) === current) return;
      current = String(v.id);
      showVariantImage(v.media, true);
    });

    if (/[?&]variant=/.test(location.search)) {
      try {
        var data = document.querySelector('bloom-buybox [data-bloom-variants]');
        var list = data ? JSON.parse(data.textContent) : [];
        var sel = list.filter(function (x) { return String(x.id) === current; })[0];
        if (sel) showVariantImage(sel.media, false);
      } catch (err) { /* ohne Daten bleibt das Startbild */ }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
